import React from "react";

import TeamIcon from "@components/icons/TeamIcon";
import { WrappedLink } from "@components/navigation";
import { EventType } from "@gp/models";
import { getCurrentCulture } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import classNames from "classnames";
import { observer } from "mobx-react";

type QuickPlayPopupsTeamsProps = {
	sportData: {
		eventType?: EventType;
		eventName?: string | null;
		showCountryFlag?: boolean;
		teamOneCountryCode?: string;
		teamTwoCountryCode?: string;
		teamOneJerseyTypeAbrv?: string;
		teamTwoJerseyTypeAbrv?: string;
		teamOneName?: string;
		teamTwoName?: string;
	};
	eventId?: string;
	sportId?: string;
	className?: string;
	containerClassName?: string;
	iconClassName?: string;
	teamNameClassName?: string;
	isLive?: boolean;
	isLinkDisabled?: boolean;
	isBetBuilder?: boolean;
};

export const QuickPlayPopupsTeams = observer(
	(props: QuickPlayPopupsTeamsProps) => {
		if (!props.sportData) {
			return null;
		}

		const {
			containerClassName = "card--qp__competitor card--bbp__competitor card--qp--nowrap__competitor card--bbp--nowrap__competitor",
			iconClassName = "card--qp__icon card--bbt__icon u-icon u-icon--med",
			teamNameClassName = "card--qp__team card--mpt__team card--qp--nowrap__team card--mpt--nowrap__team",
		} = props;

		if (
			props.sportData?.eventType != null &&
			props.sportData?.eventType !== EventType.NORMAL &&
			props.sportData?.eventName != ""
		) {
			return (
				<div className={classNames("event-name", props.className)}>
					{props.sportData.eventName}
				</div>
			);
		}

		const linkUrl = props.isLive
			? `/${getCurrentCulture()}/${DefaultPath.LIVE}/${
					props.eventId
				}-myBets=false`
			: `/${getCurrentCulture()}/sports/full?eventId="${
					props.eventId
				}"&sportId="${
					props.sportId
				}"&isAdditionalLive=false&myBets=false&${props.isBetBuilder ? "bb=true" : ""}`;

		const content = (
			<>
				<div className={containerClassName}>
					<TeamIcon
						showCountryFlag={props.sportData.showCountryFlag ?? false}
						flagCode={props.sportData.teamOneCountryCode}
						jerseyTypeAbrv={props.sportData.teamOneJerseyTypeAbrv}
						opponentFlagCode={props.sportData?.teamTwoCountryCode}
						opponentJerseyTypeAbrv={props.sportData?.teamTwoJerseyTypeAbrv}
						className={iconClassName}
					/>
					<span className={teamNameClassName}>
						{props.sportData.teamOneName}
					</span>
				</div>
				<div className={containerClassName}>
					<TeamIcon
						showCountryFlag={props.sportData.showCountryFlag ?? false}
						flagCode={props.sportData.teamTwoCountryCode}
						jerseyTypeAbrv={props.sportData.teamTwoJerseyTypeAbrv}
						opponentFlagCode={props.sportData?.teamOneCountryCode}
						opponentJerseyTypeAbrv={props.sportData?.teamOneJerseyTypeAbrv}
						className={iconClassName}
					/>
					<span className={teamNameClassName}>
						{props.sportData.teamTwoName}
					</span>
				</div>
			</>
		);

		return props.isLinkDisabled ? (
			content
		) : (
			<WrappedLink
				to={linkUrl}
				className={
					props.className ||
					"card--pick__competitors card--pick__competitors--clamp card--pick__link"
				}
				onClick={(e: React.MouseEvent) => e.stopPropagation()}
				title={`${props.sportData.teamOneName} - ${props.sportData.teamTwoName}`}
			>
				{content}
			</WrappedLink>
		);
	}
);
